module.exports = __webpack_public_path__ + "img/Ainsley Maitland-Niles.53d0f20c.png";